/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IHeaderImageMetaData, ILanguage, IProduct, ISettings } from '../../api/domain';

enum SettingsApiActions {
    SETTINGS_INITIALIZED = 'configuration.api.initialized',
    FETCH_SETTINGS = 'configuration.api.fetch',
    FETCH_SETTINGS_SUCCESS = 'configuration.api.fetch.success',
    FETCH_SETTINGS_FAILURE = 'configuration.api.fetch.failure',

    SET_HEADER_IMAGE_METADATA = 'configuration.api.set-header-image-data',

    FETCH_PRODUCTS = 'configuration.api.fetch-products',
    FETCH_PRODUCTS_SUCCESS = 'configuration.api.fetch-products.success',
    FETCH_PRODUCTS_FAILURE = 'configuration.api.fetch-products.failure',

    FETCH_LANGUAGES = 'configuration.languages.api.fetch',
    FETCH_LANGUAGES_SUCCESS = 'configuration.languages.api.fetch.success',
    FETCH_LANGUAGES_FAILURE = 'configuration.languages.api.fetch.failure',
}

export const setSettingsInitialized = createAction(SettingsApiActions.SETTINGS_INITIALIZED);
export const fetchSettings = createAction(SettingsApiActions.FETCH_SETTINGS);
export const fetchSettingsSuccess = createAction<ISettings>(SettingsApiActions.FETCH_SETTINGS_SUCCESS);
export const fetchSettingsFailure = createAction(SettingsApiActions.FETCH_SETTINGS_FAILURE);

export const fetchProducts = createAction<string[] | undefined>(SettingsApiActions.FETCH_PRODUCTS);
export const fetchProductsSuccess = createAction<{
    products: IProduct[];
    categories: string[];
}>(SettingsApiActions.FETCH_PRODUCTS_SUCCESS);
// TODO: could not use plain string array without wrapping in object due to fetchProductsActionTaker() implementation
export const fetchProductsFailure = createAction<{ categories: string[] }>(SettingsApiActions.FETCH_PRODUCTS_FAILURE);

export const fetchLanguages = createAction(SettingsApiActions.FETCH_LANGUAGES);
export const fetchLanguagesSuccess = createAction<ILanguage[]>(SettingsApiActions.FETCH_LANGUAGES_SUCCESS);
export const fetchLanguagesFailure = createAction(SettingsApiActions.FETCH_LANGUAGES_FAILURE);

export const setHeaderImageMetaData = createAction<IHeaderImageMetaData>(SettingsApiActions.SET_HEADER_IMAGE_METADATA);
